/**
 * Единый словарь пользовательских текстов панели предприятия (ТЗ §8.1:
 * «тексты — в файлах перевода, без захардкоженных строк в компонентах»).
 */
export const ru = {
  app: {
    name: 'ПромТурТверь',
    panel: 'Кабинет предприятия',
    tagline: 'Заводы и люди',
  },
  nav: {
    scanner: 'Сканер',
    schedule: 'Слоты',
    group: 'Группа',
    reports: 'Отчёты',
    cabinet: 'Кабинет',
    programs: 'Программы',
    menu: 'Меню',
    close: 'Закрыть',
    logout: 'Выйти',
    sections: 'Разделы',
  },
  common: {
    loading: 'Загружаем данные…',
    empty: 'Пока нет данных',
    emptyDescription: 'Данные появятся после первого действия.',
    error: 'Не удалось загрузить данные',
    errorDescription: 'Проверьте соединение и повторите попытку.',
    retry: 'Повторить',
    refresh: 'Обновить',
    save: 'Сохранить',
    saving: 'Сохраняем…',
    cancel: 'Отмена',
    create: 'Создать',
    edit: 'Изменить',
    archive: 'В архив',
    delete: 'Удалить',
    close: 'Закрыть',
    apply: 'Применить',
    date: 'Дата',
    time: 'Время',
    all: 'Все',
    yes: 'Да',
    no: 'Нет',
    today: 'Сегодня',
    notSpecified: 'Не указано',
    online: 'Сеть есть',
    offline: 'Сети нет',
    saved: 'Сохранено',
    deleted: 'Удалено',
    unknownError: 'Неизвестная ошибка',
    networkError: 'Нет связи с сервером. Проверьте интернет.',
    requiredField: 'Заполните поле',
    from: 'С',
    to: 'По',
    period: 'Период',
    status: 'Статус',
    address: 'Адрес',
    phone: 'Телефон',
    email: 'E-mail',
    actions: 'Действия',
  },
  login: {
    title: 'Вход в кабинет предприятия',
    subtitle: 'Представитель предприятия · объект промышленного туризма',
    email: 'E-mail',
    emailPlaceholder: 'predstvitel@predpriyatie.ru',
    password: 'Пароль',
    passwordHint: 'Не менее 12 символов',
    submit: 'Войти',
    submitting: 'Входим…',
    twoFactorTitle: 'Подтверждение входа',
    twoFactorHint: 'Роль «Администратор региона» требует кода подтверждения. Введите код из приложения-аутентификатора.',
    twoFactorCode: 'Код подтверждения',
    twoFactorSubmit: 'Подтвердить',
    twoFactorBack: 'Вернуться ко входу',
    errorInvalid: 'Неверный e-mail или пароль.',
    errorTwoFactor: 'Неверный или просроченный код подтверждения.',
    errorNetwork: 'Нет связи с сервером. Проверьте интернет.',
    errorBlocked: 'Учётная запись заблокирована. Обратитесь к администратору региона.',
    errorForbidden: 'У этой учётной записи нет прав представителя предприятия.',
    support: 'Нет доступа? Обратитесь к администратору региона.',
    registerLink: 'Зарегистрировать предприятие',
    registerHint: 'Нет доступа к кабинету? Оставьте заявку на подключение предприятия.',
  },
  registration: {
    title: 'Регистрация предприятия',
    subtitle:
      'Заявка на подключение: после подтверждения администратора данные предприятия станут видны гостям',
    legalName: 'Название предприятия',
    legalNamePlaceholder: 'ООО «Весьегонский винзавод»',
    contactName: 'ФИО представителя',
    contactNamePlaceholder: 'Иванова Мария',
    contactPhone: 'Телефон',
    contactPhonePlaceholder: '+7 900 000-00-00',
    email: 'E-mail представителя',
    emailHint: 'Этот e-mail станет логином кабинета предприятия',
    password: 'Пароль',
    passwordRepeat: 'Пароль ещё раз',
    passwordHint: 'Не менее 12 символов',
    district: 'Район',
    districtPlaceholder: 'Кашинский район',
    inn: 'ИНН',
    innPlaceholder: '1234567890',
    slotsPerWeek: 'Готовность выделять слотов в неделю',
    slotsPerWeekPlaceholder: '2 слота в неделю',
    message: 'Комментарий',
    messagePlaceholder: 'Хотим подключиться к Платформе',
    submit: 'Отправить заявку',
    submitting: 'Отправляем…',
    successTitle: 'Заявка отправлена',
    successDescription:
      'Ожидаем подтверждения администратора региона. После подтверждения вы войдёте в кабинет по этому e-mail и паролю — данные предприятия станут доступны для настройки.',
    successRequestId: 'Номер заявки',
    successLoginLink: 'Вернуться ко входу',
    support: 'Вопросы по подключению предприятия — администратору региона.',
    errorConflict:
      'Этот e-mail уже зарегистрирован. Если кабинет уже создан — войдите по паролю, пароль можно восстановить у администратора региона.',
    errorValidation: 'Проверьте заполнение полей — сервер не принял часть данных.',
    errorNetwork: 'Нет связи с сервером. Проверьте интернет.',
    errorUnknown: 'Не удалось отправить заявку. Попробуйте ещё раз.',
    requiredField: 'Заполните поле',
    emailInvalid: 'Укажите корректный e-mail',
    passwordShort: 'Пароль должен быть не короче 12 символов',
    passwordMismatch: 'Пароли не совпадают',
    innInvalid: 'ИНН должен содержать 10 или 12 цифр',
  },
  pending: {
    title: 'Доступ ожидает подтверждения администратора',
    description:
      'Учётная запись создана, но ещё не привязана к предприятию. Как только администратор региона подтвердит заявку, вы войдёте по этому e-mail и паролю — кабинет откроется автоматически.',
    hint: 'Если заявка не обработана, обратитесь к администратору региона.',
    loginLink: 'Выйти и войти заново',
  },
  scanner: {
    title: 'Сканер пропусков',
    subtitle: 'Наведите камеру на QR-код пропуска посетителя',
    start: 'Включить камеру',
    stop: 'Выключить камеру',
    cameraActive: 'Камера включена',
    cameraStarting: 'Включаем камеру…',
    resultTitle: 'Результат проверки',
    visitor: 'Посетитель',
    guestCount: 'Гостей в группе',
    slot: 'Слот',
    safety: 'Отметка о прохождении ТБ',
    safetyPassed: 'Тест по ТБ пройден',
    safetyFailed: 'Тест по ТБ не пройден',
    safetyUnknown: 'Отметка о ТБ отсутствует',
    checkedIn: 'Проход отмечен',
    points: 'Начислено баллов',
    offlineChecked: 'Проверено офлайн',
    offlineQueued: 'Ожидает синхронизации',
    offlineKeyMissing: 'Ключ офлайн-проверки не загружен. Подключитесь к сети и обновите страницу.',
    pending: 'В очереди синхронизации',
    syncDone: 'Очередь синхронизирована',
    decodeTime: 'Время распознавания',
    perMinute: 'Сканов в минуту',
    hint: 'Распознавание — не более 1 секунды, не менее 20 сканов в минуту с одного устройства.',
    manualCode: 'Код пропуска вручную',
    manualPlaceholder: 'PT-2026-01482',
    manualSubmit: 'Проверить',
    reasonAlreadyUsed: 'Пропуск уже использован',
    reasonWrongEnterprise: 'Пропуск для другого предприятия',
    reasonExpired: 'Срок действия пропуска истёк',
    reasonRevoked: 'Пропуск отозван',
    reasonInvalidSignature: 'Подпись пропуска не прошла проверку',
    reasonInvalid: 'Пропуск не распознан',
    reasonNoDevice: 'Камера не найдена',
    reasonPermission: 'Нет доступа к камере. Разрешите доступ и включите камеру снова.',
    reasonInsecure: 'Камера доступна только по защищённому соединению (HTTPS).',
    reasonUnavailable: 'Браузер не поддерживает доступ к камере.',
    reasonUnknown: 'Не удалось включить камеру.',
    offlineDescription: 'Сеть недоступна — подпись пропуска проверена локально.',
    onlineDescription: 'Пропуск проверен сервером.',
  },
  schedule: {
    title: 'Расписание',
    subtitle: 'Слоты, дни недели, каникулы и техобслуживание',
    date: 'Дата смены',
    slotTitle: 'Слот',
    capacity: 'Вместимость',
    reserved: 'Занято',
    duration: 'Длительность',
    open: 'Открыть',
    close: 'Закрыть',
    statusOpen: 'Открыт',
    statusClosed: 'Закрыт',
    statusCancelled: 'Отменён',
    closeConfirm: 'Закрыть слот для бронирования?',
    weeklyTitle: 'Еженедельное расписание',
    weeklyDays: 'Дни недели',
    weeklyStart: 'Начало смены',
    weeklyDuration: 'Длительность экскурсии, мин',
    weeklyCapacity: 'Вместимость по умолчанию',
    blackoutTitle: 'Каникулы и техобслуживание',
    blackoutDate: 'Дата',
    blackoutReason: 'Причина',
    blackoutAdd: 'Добавить день',
    blackoutEmpty: 'Исключённых дней нет',
    dayMon: 'Пн',
    dayTue: 'Вт',
    dayWed: 'Ср',
    dayThu: 'Чт',
    dayFri: 'Пт',
    daySat: 'Сб',
    daySun: 'Вс',
    noSlots: 'На эту дату слотов нет',
    noSlotsDescription: 'Откройте слоты в еженедельном расписании.',
  },
  group: {
    title: 'Список группы',
    subtitle: 'Состав гостей, допуск и контакты',
    date: 'Дата визита',
    group: 'Группа',
    district: 'Район',
    slot: 'Слот',
    places: 'Мест',
    admission: 'Статус допуска',
    safety: 'Отметка о ТБ',
    guest: 'Гость',
    checkedIn: 'Прошёл',
    notCheckedIn: 'Не прошёл',
    contact: 'Контакт для оперативной связи',
    statusPendingPayment: 'Ожидает оплаты',
    statusConfirmed: 'Подтверждена',
    statusCancelled: 'Отменена',
    statusCompleted: 'Завершена',
    document: 'Документ',
    documentHidden: 'Данные документа скрыты',
    documentHiddenHint: 'Паспортные данные доступны только в период от брони до окончания визита включительно.',
    noGroups: 'На эту дату групп нет',
    noGroupsDescription: 'Брони появятся после записи посетителей через Mini App.',
  },
  reports: {
    title: 'Отчётность',
    subtitle: 'Посещаемость, повторные гости, загрузка слотов и выручка',
    visits: 'Посещения',
    repeatRate: 'Доля повторных гостей',
    revenue: 'Выручка',
    slotsLoad: 'Загрузка слотов',
    ageStructure: 'Возрастная структура',
    revenueByProgram: 'Выручка по программам',
    attendance: 'Посещаемость по периодам',
    exportCsv: 'Выгрузить CSV',
    load: 'Загрузка',
    noProgramRevenue: 'Данных по программам пока нет',
    period: 'Отчётный период',
  },
  programs: {
    title: 'Программы',
    subtitle: 'Экскурсии, точки показа, категория и цена',
    create: 'Новая программа',
    titleField: 'Название',
    descriptionField: 'Описание',
    durationField: 'Длительность, мин',
    priceField: 'Цена, ₽',
    priceHint: 'Цена хранится в копейках (ТЗ §7.3)',
    categoryField: 'Категория производства',
    minAgeField: 'Минимальный возраст',
    school: 'Для школьников и студентов',
    sites: 'Точки показа',
    status: 'Статус',
    statusDraft: 'Черновик',
    statusPublished: 'Опубликована',
    statusArchived: 'В архиве',
    archived: 'Архив',
    archive: 'В архив',
    confirmArchive: 'Переместить программу в архив?',
    empty: 'Программ пока нет',
    emptyDescription: 'Создайте первую экскурсию — она появится в каталоге после модерации.',
    formTitle: 'Программа',
    newProgram: 'Новая программа',
    editProgram: 'Редактирование программы',
  },
  cabinet: {
    title: 'Кабинет предприятия',
    subtitle: 'Заявки на подключение и деловые визиты',
    enterprise: 'Предприятие',
    coordinator: 'Координатор Платформы',
    coordinatorPhone: 'Телефон координатора',
    coordinatorEmail: 'E-mail координатора',
    requests: 'Заявки и деловые визиты',
    requestOnboarding: 'Подключение предприятия',
    requestBusiness: 'Деловой визит',
    contact: 'Контактное лицо',
    company: 'Компания',
    district: 'Район',
    message: 'Сообщение',
    slotsPerWeek: 'Готовность выделить слотов',
    createdAt: 'Поступила',
    changeStatus: 'Изменить статус',
    statusNew: 'Новая',
    statusInProgress: 'В работе',
    statusAnswered: 'Отвечена',
    statusRejected: 'Отклонена',
    noRequests: 'Заявок пока нет',
    noRequestsDescription: 'Заявки поступают из лендинга и из раздела деловых визитов.',
    contactPhoneMissing: 'Телефон не указан',
  },
  categories: {
    machine_building: 'Машиностроение',
    folk_crafts: 'Народные промыслы',
    food_industry: 'Пищевая промышленность',
    it_and_innovation: 'IT и инновации',
    energy: 'Энергетика',
    chemical_industry: 'Химическая промышленность',
    other: 'Другое',
  },
} as const;

export type RuDictionary = typeof ru;
